import AvatarGroup from "@mui/material/AvatarGroup";
import { getIndividualByUserId } from "marketplace/entities/individual/realtime-store/individuals-redux-slice";
import IndividualAvatar from "marketplace/view/individual-avatar";
import NetworkedGroup from "users/entities/networked-group/networked-group";
import Session from "users/session/session";

interface AvatarGroupProps {
  group: NetworkedGroup;
  session: Session;
  avatarGroupMax?: number;
}

const DEFAULT_AVATAR_GROUP_MAX = 5;

export default function NetworkedGroupAvatarGroup(props: Readonly<AvatarGroupProps>) {

  const { group, session, avatarGroupMax } = props;

  const individuals = group?.memberUserIds?.map((userId) => getIndividualByUserId(userId));

  return (
    <AvatarGroup max={avatarGroupMax ?? DEFAULT_AVATAR_GROUP_MAX}>
      {individuals?.map((individual, idx) => (
        <IndividualAvatar
          key={individual?.userId?.toString() ?? `individual-${idx}`}
          avatarId={individual?.profile?.avatarId}
          individualId={individual?.id}
          session={session}
        />
      ))}
    </AvatarGroup>
  );
}
